import React, {Component} from 'react'
import {JOB_SHIPPING_CARRIER} from "../../helper/jobFilter"
import PropTypes from 'prop-types'
import SelectFilterOptions from "../../../shared/SelectFilterOptions"

class FilterShippingCarrier extends Component {
    _handleChangeSelect = (field, value) => {
        const {onChangeSelect} = this.props

        if (typeof onChangeSelect === 'function') {
            onChangeSelect(field, value)
        }
    }

    render() {
        const {shipping} = this.props

        return (
            <div className="FilterShippingCarrier col-12 col-xl-auto mb-3">
                <SelectFilterOptions
                    defaultValue={shipping}
                    handleChange={this._handleChangeSelect}
                    listOptions={JOB_SHIPPING_CARRIER}
                    field="shipping_carrier" label="Shipping carrier"
                />
            </div>
        )
    }
}

FilterShippingCarrier.propTypes = {
    shipping: PropTypes.string,
    onChangeSelect: PropTypes.func.isRequired
}

export default FilterShippingCarrier